import {
  DollarSign,
  Eye,
  TrendingUp,
  ShoppingBag,
  CircleDollarSign,
  Layers,
  Megaphone,
} from 'lucide-react';
import { KpiTile } from '../../_shared/KpiTile';
import {
  CURRENCY,
  COMPACT_NUMBER,
  NUMBER,
  PERCENT,
  RATIO_X,
} from '../../_shared/format';
import type { PerformanceCampaignSummary } from '@/services/api';

export function CampaignDrilldownHero({
  summary,
}: {
  summary: PerformanceCampaignSummary;
}) {
  return (
    <div className="space-y-4">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <Megaphone size={18} className="text-indigo-500" />
          <div>
            <div className="text-[10px] font-mono uppercase text-slate-400">
              Performance · Campaign
            </div>
            <h1 className="text-lg font-bold text-navy-900">
              {summary.campaign_name}
            </h1>
          </div>
        </div>
        <div className="flex gap-2 items-center">
          {summary.objective ? (
            <span className="rounded bg-slate-100 px-2 py-1 text-[10px] font-mono text-slate-600">
              {summary.objective.replace(/^OUTCOME_/, '')}
            </span>
          ) : null}
          {summary.top_persona ? (
            <span className="rounded bg-teal-50 px-2 py-1 text-[10px] font-mono text-teal-700">
              Top: {summary.top_persona} ({PERCENT(summary.top_persona_share_pct, 0)})
            </span>
          ) : null}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3">
        <KpiTile
          label="Spend"
          value={CURRENCY.format(summary.spend)}
          icon={<DollarSign size={12} />}
        />
        <KpiTile
          label="Impressions"
          value={COMPACT_NUMBER.format(summary.impressions)}
          icon={<Eye size={12} />}
        />
        <KpiTile label="CTR" value={PERCENT(summary.ctr)} icon={<TrendingUp size={12} />} />
        <KpiTile
          label="Purchases"
          value={NUMBER.format(summary.purchases)}
          icon={<ShoppingBag size={12} />}
        />
        <KpiTile
          label="ROAS"
          value={RATIO_X(summary.roas)}
          icon={<CircleDollarSign size={12} />}
          tone={summary.roas >= 1.5 ? 'success' : summary.roas >= 0.5 ? 'default' : 'warning'}
        />
        <KpiTile
          label="CPA"
          value={CURRENCY.format(summary.cpa)}
          sub={`CPM ${CURRENCY.format(summary.cpm)}`}
        />
        <KpiTile
          label="Active Ads"
          value={NUMBER.format(summary.unique_ad_count)}
          icon={<Layers size={12} />}
        />
      </div>
    </div>
  );
}
